<script lang="ts">
    import ErpHorizontalTwoSplitLayout from 'src/features/erp/components/erp-split-layouts/ErpHorizontalTwoSplitLayout.svelte';
    import ReportOptimisationDayOverview from './ReportOptimisationDayOverview.svelte';
    import ReportOptimisationOverallOverview from './ReportOptimisationOverallOverview.svelte';
</script>

<ErpHorizontalTwoSplitLayout pageClass="sutor-report-optimisation-overviews">
    <ReportOptimisationDayOverview slot="left-panel"/>
    <ReportOptimisationOverallOverview slot="right-panel"/>
</ErpHorizontalTwoSplitLayout>